/**
 * 商品検索用VOクラス
 *
 * @export KYMW5002OutputModel
 * @class KYMW5002OutputModel
 */
export class KYMW5002OutputModel {

  // 設定画像配列
  /** UseImageInfoVOの配列 */
  public useImageInfoVOList: Array<any>
    = [];

  // 設定生協配列
  /** SelectCoopInfoVOの配列  */
  public selectCoopInfoVOList: Array<any>
    = [];

}
